import s from "./cookieBanner.module.scss";

export const CookieBanner = ({ onAccept, onReject, t }) => {
  return (
    <div className={s.banner}>
      <div className={s.bannerContent}>
        <p className={s.bannerTitle}>{t.legal.cookieBanner.title}</p>
        <p className={s.bannerText}>{t.legal.cookieBanner.text}</p>
      </div>
      <div className={s.bannerActions}>
        <button className={s.acceptButton} type="button" onClick={onAccept}>
          {t.legal.cookieBanner.accept}
        </button>
        <button className={s.rejectButton} type="button" onClick={onReject}>
          {t.legal.cookieBanner.reject}
        </button>
      </div>
    </div>
  );
};
